import React from 'react';
import HpsTable from './HpsTable';

const ProductHydroTable = ({ refreshTrigger, exportName }) => (
  <HpsTable
    procurementTypeHeader='1'
    refreshTrigger={refreshTrigger}
    exportName={exportName}
  />
);

export default React.memo(ProductHydroTable);
